var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "classroomArrangement" },
    [
      _c("div", { staticClass: "classroomArrangement-page" }, [
        _c(
          "div",
          { staticClass: "classroomArrangement-leftpage" },
          [_c("leftClassroomArrangement", { attrs: { data: _vm.leftData } })],
          1
        ),
        _c(
          "div",
          { staticClass: "classroomArrangement-rightpage" },
          [
            _c("rightClassroomArrangement", {
              attrs: { data: _vm.rightData },
              on: { clickMore: _vm.clickMore },
            }),
          ],
          1
        ),
      ]),
      _c(
        "van-popup",
        {
          staticClass: "pop-page",
          attrs: {
            position: "center",
            "get-container": "#app",
            closeable: true,
          },
          model: {
            value: _vm.show,
            callback: function ($$v) {
              _vm.show = $$v
            },
            expression: "show",
          },
        },
        [
          _c("div", { staticClass: "pop-content" }, [
            _c("div", { staticClass: "pop-title" }, [_vm._v("未开始安排")]),
            _c(
              "div",
              { staticClass: "pop-list" },
              [
                _vm.rightData.length != 0
                  ? _c(
                      "van-grid",
                      { attrs: { "column-num": 3, gutter: 20, border: false } },
                      _vm._l(_vm.moreList, function (item, index) {
                        return _c(
                          "van-grid-item",
                          { key: index },
                          [
                            _c("classroomArrangementMoreItem", {
                              attrs: { item: item },
                            }),
                          ],
                          1
                        )
                      }),
                      1
                    )
                  : _c("div", { staticClass: "arrange-nodata" }, [
                      _c("div", { staticClass: "content" }, [
                        _c("img", {
                          attrs: {
                            src: require("_teas/public/img/product/bootScreen/img-null.png"),
                            alt: "",
                            srcset: "",
                          },
                        }),
                        _c("div", { staticClass: "text" }, [
                          _vm._v("暂无当前课程/会议"),
                        ]),
                      ]),
                    ]),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }